import React from "react";
import format from "date-fns/format";
import PropTypes from "prop-types";
// Material imports
import Typography from "@mui/material/Typography";
import makeStyles from "@mui/styles/makeStyles";
const useStyles = makeStyles(theme => ({
  caption: {
    color: theme.palette.contrast.text
  }
}));
const TimePosted = ({
  time
}) => {
  const classes = useStyles();
  const formattedTime = format(time, "H:mm");
  return /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    classes: {
      caption: classes.caption
    }
  }, formattedTime);
};
export default TimePosted;
TimePosted.propTypes = {
  time: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};